import * as React from "react";
import Svg, { Rect, G, Path } from "react-native-svg";

function SvgComponent(props) {
  return (
    <Svg
      width={38}
      height={38}
      viewBox="0 0 38 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <Rect width={38} height={38} rx={8} fill="#F9F9F9" />
      <G fill="#333">
        <Path d="M22.113 19.425a5.718 5.718 0 005.713-5.712A5.72 5.72 0 0022.113 8a5.72 5.72 0 00-5.713 5.713 5.718 5.718 0 005.713 5.712zm.134-5.336h-.27c-.679 0-1.231-.552-1.231-1.232 0-.597.427-1.095.992-1.207v-.351a.375.375 0 11.751 0v.327h.614a.375.375 0 110 .75h-1.126a.482.482 0 000 .963h.123c.005 0 .009-.003.014-.003.005 0 .009.002.013.003h.12a1.233 1.233 0 01.242 2.439v.351a.375.375 0 11-.75 0v-.327h-.618a.375.375 0 110-.75h1.126a.482.482 0 000-.963zM29.93 20.873a1.016 1.016 0 00-1.348-.007l-4.443 3.89c-.024.021-.053.032-.081.046a1.532 1.532 0 01-1.36.572l-4.673-.487a.375.375 0 11.078-.747l4.673.488a.792.792 0 00.762-1.188.784.784 0 00-.498-.367l-6.896-1.627a3.716 3.716 0 00-3.152.691l-2.698 2.108 3.06 3.94.188-.148a3.51 3.51 0 012.9-.663l5.1 1.095a2.775 2.775 0 002.448-.663l5.946-5.426c.215-.196.332-.464.331-.755a1.005 1.005 0 00-.338-.752zM12.948 28.976a.364.364 0 01-.07-.184l-3.37-4.341a.904.904 0 00-1.233-.188l-.955.667a.738.738 0 00-.312.506.74.74 0 00.156.574l3.773 4.71a.75.75 0 001.05.118l.834-.665a.91.91 0 00.25-1.096.368.368 0 01-.123-.1z" />
      </G>
    </Svg>
  );
}

export default SvgComponent;
